import React, { useState, memo } from "react";
// import service
import { createManualUser } from "../services/admin.service";
// import validation
import { createManualUserValid } from "../validation/admin.validation";
// import lib
import toastAlert from '../lib/toastAlert';
import isEmpty from "../lib/isEmpty";
import { useEffect } from "react";

const initialValue = {
    userName: "",
    email: "",
    phone: "",
    password: ""
};

const AddManualUser = ({ showModal, setShowModal, fetchData }) => {

    const [formValue, setFormValue] = useState(initialValue);
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const { userName, email, phone, password } = formValue;

    const handleChange = ({ target: { name, value } }) => {
        setFormValue({ ...formValue, ...{ [name]: value } });
    }

    const handleBlur = ({ target: { name } }) => {
        setTouched({ ...touched, ...{ [name]: true } });
    }

    const handleSubmit = async () => {
        try {
            setLoader(true);
            const { status, message, errors } = await createManualUser(formValue);
            setLoader(false);
            if (status === true) {
                setFormValue(initialValue)
                setErrors({})
                setTouched({})
                toastAlert('success', message, 'createManualUser')
                setShowModal(false);
                fetchData();
            } else if (!isEmpty(errors)) {
                setErrors(errors)
            } else if (message) {
                toastAlert('error', message, 'createManualUser')
            }
        } catch (error) {
            console.error('Error generating pins:', error);
            setLoader(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            const { status, errors } = createManualUserValid(formValue);
            if (!status) setErrors(errors);
            else setErrors({});
        }
    }, [showModal, formValue])

    if (!showModal) return null
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">Create User</h2>
                    <button
                        onClick={() => {
                            setShowModal(false);
                            setFormValue(initialValue)
                            setErrors({})
                            setTouched({})
                        }}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Email
                        </label>
                        <input
                            type="text"
                            value={email}
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="Enter email"
                        />
                        {touched?.email && <p className="mt-1 text-sm text-red-400">{errors?.email}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Username
                        </label>
                        <input
                            type="text"
                            value={userName}
                            name="userName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="Enter username"
                        />
                        {touched?.userName && <p className="mt-1 text-sm text-red-400">{errors?.userName}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Phone Number
                        </label>
                        <input
                            type="text"
                            value={phone}
                            name="phone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="Enter Phone Number"
                        />
                        {touched?.phone && <p className="mt-1 text-sm text-red-400">{errors?.phone}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Password
                        </label>
                        <input
                            type="text"
                            value={password}
                            name="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-all"
                            placeholder="Enter Password"
                        />
                        {touched?.password && <p className="mt-1 text-sm text-red-400">{errors?.password}</p>}
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            onClick={() => {
                                setShowModal(false);
                                setFormValue(initialValue)
                                setErrors({})
                                setTouched({})
                            }}
                            className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-all"
                            disabled={loader}
                        >
                            Close
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={loader || !isEmpty(errors)}
                            className="flex-1 px-4 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg font-semibold hover:from-cyan-600 hover:to-blue-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        >
                            {loader ? (
                                <>
                                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    Loading...
                                </>
                            ) : (
                                'Save'
                            )}
                        </button>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default memo(AddManualUser);